import React from 'react';
import styled from 'styled-components';
import Typography from '../Typography';
import Tooltip from '../Tooltip/Tooltip';
import InfoCircleOutlineIcon from '../Icons/InfoCircleOutlineIcon';
import { theme } from '../../theme';

const CardToogle = ({
  category,
  isActive,
  onClick,
  icon,
  tooltipText,
  iconSize = '28px',
  direction = 'vertical', // Nueva prop con valor por defecto
  textAlign = 'left' // Nueva prop para alineación del texto
}) => {
  return (
    <Option $isActive={isActive} $direction={direction} onClick={onClick}>
      {icon && <StyledIcon $size={iconSize}>{icon}</StyledIcon>}
      <CategoryTitle
        as="p"
        $isActive={isActive}
        $variant="body-2-semibold"
        $textAlign={textAlign}
      >
        {category}
      </CategoryTitle>
      {tooltipText && (
        <TooltipWrapper $direction={direction}>
          <Tooltip text={tooltipText} maxWidth='230px'>
            <InfoButton>
              <InfoCircleOutlineIcon width="16px" height="16px" fill={theme.colors.defaultSubtle} />
            </InfoButton>
          </Tooltip>
        </TooltipWrapper>
      )}
    </Option>
  );
};

export default CardToogle;


const Option = styled.div`
  position: relative;
  cursor: pointer;
  border: 1px solid ${({ $isActive, theme }) => ($isActive ? theme.border.brandMain : theme.border.defaultWeak)};
  display: flex;
  flex-direction: ${({ $direction }) => $direction === 'horizontal' ? 'row' : 'column'};
  align-items: ${({ $direction }) => $direction === 'horizontal' ? 'center' : 'center'};
  justify-content: ${({ $direction }) => $direction === 'horizontal' ? 'flex-start' : 'center'};
  gap: ${({ $direction }) => $direction === 'horizontal' ? theme.sizing.xs : theme.sizing.xxs};
  // padding: ${({ theme }) => theme.sizing.sm};
  padding: ${({ $direction }) => $direction === 'horizontal' ? theme.sizing.xs : theme.sizing.sm};
  border-radius: ${({ theme }) => theme.sizing.xs};
  transition: all 0.3s;

  &:hover {
    border: 1px solid ${({ $isActive, theme }) => ($isActive ? theme.border.brandMain : theme.border.defaultWeak)};
    background-color: ${({ $isActive, theme }) => ($isActive ? theme.fill.brandAlphaMain16 : theme.fill.defaultWeak)};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.sizing.xs};
  }
`;

const CategoryTitle = styled(Typography)`
  color: ${({ $isActive, theme }) => ($isActive ? theme.colors.brandMain : theme.colors.defaultSubtle)};
  text-align: ${({ $textAlign }) => $textAlign};
`;

const TooltipWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: ${({ $direction }) => $direction === 'horizontal' ? '8px' : '8px'};
  z-index: 1;
`;

const InfoButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.sizing.sm};
  height: ${({ theme }) => theme.sizing.sm};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.fill.defaultMain};
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.fill.defaultWeak};
  }
`;

const StyledIcon = styled.span`
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};

  svg {
    width: ${({ $size }) => $size};
    height: ${({ $size }) => $size};
  }

`;